import React from "react";

export default function Alert(props) {
  return (
    <>
      <>
        {props.alert && (
          <div
            className={`alert alert-${props.alert.type} alert-dismissable fade show`}
            role="alert"
            style={{ marginTop: props.alert.mtop, transition: "all 0.5s ease" }}
          >
            <strong>{props.alert.type}</strong>: {props.alert.msg}
          </div>
        )}
      </>
    </>
  );
}
